<script lang="ts">
  // What the buyer asked for, as it appears in the thread afterwards. Deliberately plain
  // and priceless: this element states quantities and nothing else, and the company's
  // reply — a priced cart — is the thing that carries money.

  import { t } from '$lib/i18n/index.svelte';
  import type { RequestElement } from '$lib/protocol/types';

  let { element }: { element: RequestElement } = $props();
</script>

<p class="head">{t('el.request.title')}</p>
<ul>
  {#each element.items as item (item.itemId)}
    <li><span class="id">{item.itemId}</span> × {item.quantity}</li>
  {/each}
</ul>

<style>
  .head {
    margin: 0 0 6px;
    font-weight: 600;
    font-size: 14px;
  }
  ul {
    margin: 0;
    padding-left: 18px;
    font-size: 14px;
  }
  .id {
    color: var(--ink-soft);
  }
</style>
